export const getCountryFlagByCDN = (isoCode: string) => {
  return {
    src: `https://flagcdn.com/w20/${isoCode.toLowerCase()}.png`,
    srcSet: `https://flagcdn.com/w40/${isoCode.toLowerCase()}.png 2x`,
  };
};
